import { routesNames } from '@/core/constants'
import AcessarPedidoItensView from '@/views/pages/pedido/acessar/itens/AcessarPedidoItensView.vue'
import AcessarPedidoDocumentosView from '@/views/pages/pedido/acessar/documentos/AcessarPedidoDocumentosView.vue'
import LinhaDoTempoPedido from '@/views/pages/pedido/acessar/linha-do-tempo/LinhaDoTempoPedido.vue'
import OcorrenciasPedido from '@/views/pages/pedido/acessar/ocorrencias/OcorrenciasPedido.vue'
import PenalidadesPedidoView from '@/views/pages/pedido/acessar/penalidades/PenalidadesPedidoView.vue'

export default [
	{
		name: routesNames.PEDIDO.ACESSAR_ITENS_VIEW,
		path: 'itens',
		component: AcessarPedidoItensView,
		meta: {
			page: {
				title: 'Pedido',
				subtitle: 'Itens',
			},
		},
	},
	{
		name: routesNames.PEDIDO.ACESSAR_DOCUMENTOS_VIEW,
		path: 'documentos',
		component: AcessarPedidoDocumentosView,
		meta: {
			page: {
				title: 'Pedido',
				subtitle: 'Documentos',
			},
		},
	},
	{
		name: routesNames.PEDIDO.ACESSAR_LINHA_DO_TEMPO_VIEW,
		path: 'linha-do-tempo',
		component: LinhaDoTempoPedido,
		meta: {
			page: {
				title: 'Pedido',
				subtitle: 'Linha do Tempo',
			},
		},
	},
	{
		name: routesNames.PEDIDO.ACESSAR_OCORRENCIAS_VIEW,
		path: 'ocorrencias',
		component: OcorrenciasPedido,
		meta: {
			page: {
				title: 'Pedido',
				subtitle: 'Ocorrências',
			},
		},
	},
	{
		name: routesNames.PEDIDO.ACESSAR_PENALIDADES_VIEW,
		path: 'penalidades',
		component: PenalidadesPedidoView,
		meta: {
			page: {
				title: 'Pedido',
				subtitle: 'Infrações e Sanções',
			},
		},
	},
]
